module.exports = __webpack_public_path__ + "static/media/dogFrontBgDesktop.0f89b66f.webp";